import request from './request'

// 获取用户企业列表
export function tempAccessCode (data) {
  return request({
    url: 'UserAuth/TempAccessCode',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/client.api.js